<template>
  <div id="calculadora-de-pessoas" class="row">
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <div class="input-idade">
            <label>De</label>
            <input
              type="text"
              v-model="idade_inicial"
              class="form-control"
              placeholder="idade"
            />
            <label>a</label>
            <input
              type="text"
              v-model="idade_final"
              class="form-control"
              placeholder="idade"
            />
            <label for="">anos</label>
            <button
              class="btn btn-default"
              type="button"
              @click="cleanFilters()"
            >
              Limpar
            </button>
          </div>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="calculadora-de-pessoas"
          >
          </download-files>
        </div>
      </div>
      <tabela-cadastros-vuetfy
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros-vuetfy>
    </div>
  </div>
</template>

<script>
import * as Functions from './functions.js'
import utils from '@/mixins/utils.js'
import { dataFields } from './utils.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import Selects from '@/components/utils/Selects.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'

export default {
  name: 'PessoasPorIdadePorEquipeAcs',
  components: {
    TabelaCadastrosVuetfy,
    Selects,
    DownloadFiles,
  },
  mixins: [utils],
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      if (this.idade_inicial !== '' && this.idade_final !== '') {
        return this.cadastros.filter((item) => {
          let ida = parseInt(item.idade)
          return ida >= this.idade_inicial && ida <= this.idade_final
        })
      }
      return this.cadastros
    },
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  data() {
    return {
      dataFields: {
        ...dataFields,
      },
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cadastros: [],
      loading: false,
      size: '40px',
      color: '#0D98BB',
      cadastrosOriginais: [],
      idade_inicial: '',
      idade_final: '',
      filterSearchTable: false,
    }
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    cleanFilters() {
      this.idade_inicial = ''
      this.idade_final = ''
    },

    async buscarDados() {
      try {
        this.loading = true
        const response = await Functions.getDados(this.cod_ibge)
        if (response) {
          //Esvazia os valores
          this.cadastros = []
          this.cadastrosOriginais = response
          this.cadastros = response
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    generatePdf() {
      Functions.generatePdf(this.displayedCadastros)
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDados()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
